export const LocalePrice = ( price ) => {
    const the_price = parseFloat(price)
    return the_price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}